// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OWLz","content":"styles_content__5SYJ2"};